"use client";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-sky-100 via-indigo-50 to-slate-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 text-center p-6">
      
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24" 
        strokeWidth={1.5} 
        stroke="currentColor" 
        className="w-24 h-24 text-sky-500 mb-6 opacity-70"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
      </svg>

      <h1 className="text-6xl font-bold text-sky-700 dark:text-sky-400 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-100 mb-3">
        Página Não Encontrada
      </h2>
      <p className="text-gray-600 dark:text-gray-300 mb-8 max-w-md">
        Oops! Parece que a página que você está tentando acessar não existe ou foi movida.
      </p>
  
      <button
        onClick={() => window.history.back()}
        className="px-6 py-3 bg-sky-600 text-white font-semibold rounded-lg shadow-md hover:bg-sky-700 transition-colors duration-150"
      >
        Voltar
      </button>
    </div> 
  );
}